import { Observable} from 'rxjs';
import { api, handleError, retryStrategy } from '../../shared/api-loaders';
import { Injectable } from '@angular/core';
import { ServiceLogModel } from '../models/service-log.model';
import {catchError, map} from "rxjs/operators";
import {Configuration} from "../../ect-feature/models/configuration";
import { timer, of} from 'rxjs';
import { switchMap, retryWhen} from 'rxjs/operators';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';


@Injectable()
export class ServiceLogService {

  constructor(private _http: HttpClient) { }

  getLogs(params: HttpParams): Observable<ServiceLogModel[]> {
    return timer(0).pipe(
      switchMap(
      x => {
        return this._http.get<ServiceLogModel[]>(api.logs(), {params: params})
      })
      ,retryWhen(retryStrategy()));
  }

  
  /** GET */
  getLogById(id: number): Observable<Configuration> {
    return this._http
      .get(api.log(id)).pipe(
        catchError(handleError),);
  }

  /** GET */
  getLogByTraceId(id: string): Observable<Configuration> {
    return this._http
      .get(api.traceLog(id)).pipe(
        catchError(handleError),);
  }

}
